export enum MoveStationSaveStatus {
  Saving = "SAVING",
  Saved = "SAVED",
  Failed = "FAILED",
  Idle = "IDLE",
}

interface ReceiveMoveStationCommandMessage {
  status: MoveStationSaveStatus;
  error: string | null;
}

export default ReceiveMoveStationCommandMessage;
